import React from 'react';
import { Attention } from '../atoms/Attention';

export const GenericExceptionPage = () => {
  return (
    <div style={{ backgroundColor: '#fff' }}>
      <Attention title="エラーが発生しました">
        <br />
        ページの再読み込みをするか、しばらく経ってから再度アクセスしてください。
      </Attention>
    </div>
  );
};
